<template>
  <vxe-grid
    ref="vxeGrid"
    auto-resize
    highlight-hover-row
    :data="table"
    :toolbar-config="tableToolbar"
    :columns="tableColumns"
    :loading="loading"
    size="mini"
    cell-class-name="align-top"
    resizable
    round
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:showScheduleInfo="{ row }">
      <span
        >{{ row.departureCityName }} {{ '-->' }}
        {{ row.destinationCityName }}</span
      >
      <br />
      <span>{{ row.scheduleStartDate }} 至 {{ row.scheduleEndDate }}</span>
    </template>
    <template v-slot:showCustInfo="{ row }">
      <span>{{ $l('table_label_scm') || '供应商' }}：{{ row.scmName }}</span>
      <br />
      <span
        >{{ $l('INDEX.label_customer') || '客户' }}：{{ row.custName }}</span
      >
      <br />
      <span
        >{{ $l('INDEX.table_label_cust_order_no_list') || '订单' }}：{{
          row.custOrderNoList
        }}</span
      >
    </template>
    <template v-slot:opt="{ row }">
      <div>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_view') || '查看'"
          placement="top"
        >
          <i
            class="el-icon-view tool-btn"
            @click="
              $emit('openDetailDialog', {
                type: 'detail',
                form: row,
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_edit') || '编辑'"
          placement="top"
          v-if="!disabled"
        >
          <i
            class="el-icon-edit tool-btn"
            @click="
              $emit('openDetailDialog', {
                type: 'edit',
                form: row,
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
          v-if="!disabled"
        >
          <i class="el-icon-delete tool-btn" @click="del(row)"></i>
        </el-tooltip>
      </div>
    </template>
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: tableColumns(this),
      table: {},
    }
  },
  watch: {
    tableData: {
      handler() {
        this.getData()
      },
      immediate: true,
    },
  },
  methods: {
    getData() {
      this.table = this.tableData
    },

    del(row) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        let index = this.$refs.vxeGrid.getRowIndex(row)
        this.table.splice(index, 1)
      })
    },
    getCheckboxRecords(type = 'code') {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据！',
          type: 'warning',
        })
        return
      }
      if (type === 'code') {
        return data.map((row) => {
          return row.userTripRequestScheduleCode
        })
      }
      return data
    },
    removeCheckboxRow() {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据！',
          type: 'warning',
        })
        return
      }
      this.$refs.vxeGrid.removeCheckboxRow()
    },
  },
}
</script>
